import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { COMPANY, MEDIA } from "@/lib/constants";

const SOCIALS = [
  {
    name: "Instagram",
    handle: COMPANY.instagramHandle,
    desc: "Bastidores, atendimentos reais e novidades da frota.",
    href: COMPANY.instagram,
    icon: Instagram,
    gradient:
      "linear-gradient(135deg,#feda75 0%,#fa7e1e 25%,#d62976 50%,#962fbf 75%,#4f5bd5 100%)",
    cta: "Seguir no Instagram",
    testid: "social-instagram-card",
  },
  {
    name: "Facebook",
    handle: COMPANY.facebookHandle,
    desc: "Avaliações, depoimentos e nossos serviços em destaque.",
    href: COMPANY.facebook,
    icon: Facebook,
    gradient: "linear-gradient(135deg,#1877f2 0%,#0a4ea8 100%)",
    cta: "Curtir no Facebook",
    testid: "social-facebook-card",
  },
];

export const Social = () => {
  return (
    <section
      id="redes"
      data-testid="social-section"
      className="section-pad bg-[#0a0a0a] relative overflow-hidden border-y border-[#2d3748]"
    >
      <div className="absolute inset-0 grid-bg opacity-25"></div>
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-[#d90429]/10 blur-3xl rounded-full pointer-events-none"></div>

      <div className="container-custom relative">
        <div className="max-w-3xl mb-12 text-center mx-auto">
          <span className="overline">Acompanhe a Ventania</span>
          <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
            Siga nossas <span className="text-[#d90429]">redes sociais</span>
          </h2>
          <p className="mt-5 text-gray-400 text-lg">
            Veja atendimentos reais, novidades da frota e fique por dentro de
            tudo que rola no dia a dia da Auto Socorro Ventania.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {SOCIALS.map((s) => {
            const Icon = s.icon;
            return (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={s.testid}
                className="card-dark p-7 md:p-8 group relative overflow-hidden"
              >
                <div
                  className="absolute -top-16 -right-16 w-44 h-44 rounded-full opacity-30 group-hover:opacity-60 blur-2xl transition-opacity"
                  style={{ background: s.gradient }}
                ></div>

                <div className="relative flex items-start justify-between mb-6">
                  <div
                    className="w-14 h-14 flex items-center justify-center rounded-xl shadow-lg"
                    style={{ background: s.gradient }}
                  >
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <ArrowUpRight className="w-6 h-6 text-gray-500 group-hover:text-[#d90429] group-hover:rotate-12 transition-all" />
                </div>

                <h3 className="font-display uppercase font-bold text-white text-2xl md:text-3xl leading-tight">
                  {s.name}
                </h3>
                <div className="mt-1 text-[#d90429] font-display uppercase tracking-wider text-sm">
                  {s.handle}
                </div>
                <p className="mt-4 text-gray-400 text-sm leading-relaxed">
                  {s.desc}
                </p>

                <div className="mt-6 inline-flex items-center gap-2 font-display uppercase tracking-wider text-white text-sm border-b border-[#d90429] pb-1 group-hover:gap-3 transition-all">
                  {s.cta} →
                </div>
              </a>
            );
          })}
        </div>

        <div className="mt-10 flex items-center justify-center gap-3 text-gray-400 text-sm">
          <img
            src={MEDIA.logo}
            alt="Auto Socorro Ventania"
            className="h-10 w-10 object-contain"
          />
          <span className="font-display uppercase tracking-wider">
            #AutoSocorroVentania · Ribeirão Preto
          </span>
        </div>
      </div>
    </section>
  );
};
